var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditConnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_1373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5579 13.0161C11.5304 13.0161 12.155 13.6983 12.3212 14.1283C12.503 14.602 12.5092 15.3162 12.113 15.8453C11.5646 16.5784 10.4149 16.7315 9.54647 16.7315C9.3243 16.7315 9.09126 16.7213 8.8489 16.7023C9.29944 15.7432 9.30566 14.8162 9.31032 14.1443C9.31187 13.8732 9.31498 13.468 9.3678 13.3354C9.37712 13.3281 9.39421 13.3179 9.42063 13.3047C9.81213 13.1123 10.1943 13.0147 10.5579 13.0147M10.5579 11.5571C9.97837 11.5571 9.35227 11.6927 8.69976 12.0148C6.61483 13.0395 9.17205 15.631 5.96387 17.6556C7.37143 18.0287 8.55682 18.189 9.54647 18.189C13.7241 18.189 14.4372 15.341 13.7816 13.6342C13.3807 12.5891 12.1503 11.5586 10.5579 11.5586V11.5571Z",
    fill: "#E89535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6887 1.61062C21.828 0.953255 20.5618 1.07569 19.8612 1.88318L12.4925 10.3779C12.4474 10.4303 12.4055 10.4843 12.3682 10.5382C13.6406 10.8486 14.5883 11.7625 14.9425 12.6837C15.0031 12.8411 15.0528 13.0073 15.0901 13.1793C15.2827 13.07 15.4614 12.93 15.6105 12.7566L22.9792 4.26192C23.6799 3.45443 23.5494 2.26652 22.6887 1.60916V1.61062Z",
    fill: "#E89535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 26.5L0 20.0007V6.99927L12 0.5L15.7892 2.55225C16.347 2.85396 16.5381 3.52298 16.2165 4.04625C15.8949 4.56951 15.1818 4.74734 14.624 4.44708L12 3.02596L2.3304 8.26152V18.737L12 23.974L21.6696 18.737V7.6304C21.6696 7.02696 22.1916 6.53722 22.8348 6.53722C23.478 6.53722 24 7.02696 24 7.6304V19.9993L12 26.4985V26.5Z",
    fill: "#E89535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_1373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditConnect);
export default __webpack_public_path__ + "static/media/edit-connect.08cbb4accf68c53ac7be93476dc01d60.svg";
export { ForwardRef as ReactComponent };